module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_okayama-d498c6b7a39abae3001e5fe5420ee18d.png";